export default __webpack_public_path__ + "static/media/iconToggleList.010802c0.svg";